/**
 * empIncentivesApi.js
 * -------------------
 * API client for Employee Self-Service Incentives module.
 * Connects directly to FastAPI endpoint /self-service/emp-incentives/ adhering to Rule 90.
 */
import api from '../../../../api/client';

export const PAYHEAD_OPTIONS = [
  { value: 'All', label: 'All Pay Heads' },
  { value: 'Performance Bonus', label: 'Performance Bonus' },
  { value: 'Project Milestone Incentive', label: 'Project Milestone Incentive' },
  { value: 'Sales & Delivery Commission', label: 'Sales & Delivery Commission' },
  { value: 'Annual Excellence Award', label: 'Annual Excellence Award' },
  { value: 'Festival Bonus', label: 'Festival Bonus' },
  { value: 'Innovation & Patent Bounty', label: 'Innovation & Patent Bounty' },
];

export const empIncentivesApi = {
  getList: async () => {
    try {
      const response = await api.get('/self-service/emp-incentives/');
      return { data: response.data.data || [] };
    } catch (err) {
      console.warn('Failed to fetch employee incentives from server:', err);
      return { data: [] };
    }
  },
};
